import { ApiResponse } from 'store/interfaces';
import { StorageResponse } from 'store/storage/storage';

export interface Filters {
  page: number;
  itemsPerPage: number;
  isActive: boolean;
  employee: string;
  type: string[] | string;
  variant: string[] | string;
}

export interface Agreement {
  id: number;
  employee: string;
  position: string;
  type: AgreementType;
  variant: string;
  dateFrom: string;
  dateTo: string | null;
  amount: number;
  amountType: AgreementAmountType;
  billingType: AgreementBillingType;
  minutesPerWeek: number;
  files: StorageResponse[];
  active: boolean;
  status: AgreementStatuses;
  currency: string;
  jobSize: number;
}

export interface AgreementsData extends ApiResponse {
  'hydra:member': Agreement[];
}

export enum AgreementType {
  AGREEMENT = 'agreement',
  ANNEX = 'annex',
  TERMINATION = 'termination',
  LIST_OF_INTENT = 'list-of-intent',
}

export enum AgreementBillingType {
  PER_HOUR = 'per-hour',
  PER_DAY = 'per-day',
  PER_WEEK = 'per-week',
  PER_MONTH = 'per-month',
}

export enum AgreementAmountType {
  BRUTTO = 'brutto',
  NETTO = 'netto',
}

export enum AgreementStatuses {
  active = 'active',
  finishing = 'finishing',
  notStarted = 'not-started-yet',
  freshlyFinished = 'freshly-finished',
  inactive = 'inactive',
}

export interface AgreementPatchMutationRequest
  extends Partial<
    Omit<
      Agreement,
      'id' | 'files' | 'variant' | 'employee' | 'active' | 'status'
    >
  > {
  id: number;
}

export interface AgreementPostMutationRequest
  extends Omit<Agreement, 'id' | 'files' | 'active' | 'status'> {}
